import text from './text';

const base = {
  cursor: 'pointer',
  outline: 'none',
  '&:disabled': {
    cursor: 'default',
    '&:hover': {
      boxShadow: 'none'
    }
  },
  flexShrink: 0
};

const hoverStyle = {
  primary: {
    '&:hover': {
      boxShadow: 'button'
    }
  },
  secondary: {
    '&:hover': {
      bg: 'primary'
    }
  }
};

const disabledStyle = {
  primary: {
    '&:disabled': {
      cursor: 'default',
      bg: 'disabled',
      '&:hover': {
        boxShadow: 'none'
      }
    }
  },
  secondary: {
    '&:disabled': {
      cursor: 'default',
      '&:hover': {
        bg: 'inherit'
      }
    }
  }
};

export default {
  primary: {
    // Default button: primary.large
    ...base,
    ...text.medium.bold,
    bg: 'primary',
    color: 'white',
    borderRadius: 'buttons.large',
    padding: 'buttons.large',
    small: {
      ...base,
      ...text.small.bold,
      ...hoverStyle.primary,
      ...disabledStyle.primary,
      bg: 'primary',
      color: 'white',
      borderRadius: 'buttons.small',
      padding: 'buttons.small'
    },
    large: {
      ...base,
      ...text.medium.bold,
      ...hoverStyle.primary,
      bg: 'primary',
      color: 'white',
      borderRadius: 'buttons.large',
      padding: 'buttons.large',
      ...disabledStyle.primary
    }
  },
  secondary: {
    small: {
      ...base,
      ...text.small.bold,
      ...hoverStyle.secondary,
      bg: 'white',
      color: 'primary',
      border: (t) => `1px solid ${t.colors.primary}`,
      borderRadius: 'buttons.small',
      padding: 'buttons.small',
      teal: {
        ...base,
        ...text.small.bold,
        bg: 'white',
        color: 'secondary',
        border: (t) => `1px solid ${t.colors.secondary}`,
        borderRadius: 'buttons.small',
        padding: 'buttons.small',
        '&:hover': {
          bg: 'primary'
        },
        ...disabledStyle.secondary
      }
    },
    large: {
      ...base,
      ...text.medium.bold,
      ...hoverStyle.secondary,
      bg: 'white',
      color: 'primary',
      border: (t) => `1px solid ${t.colors.primary}`,
      borderRadius: 'buttons.large',
      padding: 'buttons.large',
      grey: {
        ...base,
        ...text.medium.bold,
        ...hoverStyle.secondary,
        bg: 'white',
        color: 'smoke.light',
        border: (t) => `1px solid ${t.colors.secondary}`,
        borderRadius: 'buttons.large',
        padding: 'buttons.large',
        '&:hover': {
          bg: 'primary',
          color: 'text'
        }
      },
      teal: {
        ...base,
        ...text.medium.bold,
        ...hoverStyle.secondary,
        bg: 'white',
        color: 'secondary',
        border: (t) => `1px solid ${t.colors.secondary}`,
        borderRadius: 'buttons.large',
        padding: 'buttons.large',
        '&:hover': {
          bg: 'primary'
        }
      }
    }
  },
  icon: {
    ...base,
    zIndex: 0,
    '&:hover,&:active': { outline: 'none' }
  },
  close: {
    cursor: 'pointer',
    color: 'text',
    '&:hover': {
      color: 'primary'
    }
  },
  borderless: {
    ...base,
    ...text.medium.bold,
    px: 15,
    bg: 'transparent',
    color: 'primary',
    '&:hover': {
      color: 'text'
    }
  }
};
